__webpack_require__.p = "/bajainnotech/";